import React from 'react'
import HeaderMain from '../../../Compoents/HeaderMain';
import BreadcrumbArea from '../../../ShearOne/BreadcrumbArea';
import FooterWhite from '../../../Compoents/FooterWhite';
import { Link } from 'react-router-dom';


export const ClinicalEvaluation = () => {
    const breadcrumbLinks = [
        { path: '/', label: 'Home' },
        { label: 'Clinical Evaluation', active: true }
      ];
      return (
        <>
        <HeaderMain/>
        <main>
       
       <BreadcrumbArea 
         title="Clinical Evaluation" 
         backgroundImage="/assets/imgs/breadcrumb/page-header-1.png" 
         links={breadcrumbLinks} 
       />
<section class="service-details section-space">
    <div class="container">
        <div class="row flex-xl-row flex-column-reverse">
            <div class="col-xl-4">
                <div class="sidebar sidebar-rr-sticky">
                    <div class="sidebar__widget-service mb-30">
                        <Link to="/service">Medical Device Manufacturers <i class="fa-solid fa-plus"></i> </Link>
                        <Link to="/pharmaceutical-details">Pharmaceutical & Biotech industry<i class="fa-solid fa-plus"></i> </Link>
                        <Link to="/healthcare-details">Healthcare Providers <i class="fa-solid fa-plus"></i> </Link>
                    </div>
                    <div class="sidebar__widget-contact__service text-center">
                        <h4 class="mb-25 title-animation text-capitalize">Are You ready to contact with us</h4>
                        <p class="mb-20"><a href="tel:+86 19811976744"><i class="fa-solid fa-phone"></i>(+86) 19811976744</a></p>
                        <Link to="/contact-us#" class="rr-btn">
                            <span class="btn-wrap">
                                <span class="text-one">Contact Us <i class="fa-solid fa-plus"></i></span>
                                <span class="text-two">Contact Us <i class="fa-solid fa-plus"></i></span>
                            </span>
                        </Link>
                    </div>
                </div>
            </div>
            <div class="col-xl-8">
                <div class="service-details__content">
                    <div class="service-details__content-media mb-20">
                        <img src="./assets/imgs/service-details/service-details-1.jpg" class="img-fluid" alt="img not found"/>
                    </div>
                    <h2 class="title-animation mb-20">Clinical Evaluation</h2>
                    <p class="mb-20">Clinical evaluation is the process of assessing a medical device's safety, performance, and clinical benefits through the analysis of clinical data. It typically involves reviewing existing literature, clinical studies, and post-market data to establish evidence supporting the device's intended use.</p>
                    <p class="mb-30">This evaluation is crucial for obtaining regulatory approval and is often required throughout the device's lifecycle. Continuous updates are necessary as new data becomes available to ensure compliance with regulatory standards.</p>
                    <h3 class="title-animation mb-10">SQUARE MEDTECH Expertise in Clinical Evaluation</h3>
                    <p class="mb-30">SQUARE MEDTECH assists in developing the necessary clinical evidence for your medical device, ensuring alignment with your intended purpose, claims, and technical documentation through proper planning and execution of clinical evaluations.</p>
                    <ul class="mb-40">
                        <li><span><i class="fa-solid fa-check"></i></span><h5>Efficient Clinical Data Strategy</h5></li>
                        <li><span><i class="fa-solid fa-check"></i></span><h5>Ensures device safety, performance, and clinical benefits</h5></li>
                        <li><span><i class="fa-solid fa-check"></i></span><h5>Clinical Evaluation SOP to meet regulatory requirements</h5></li>
                        <li><span><i class="fa-solid fa-check"></i></span><h5>Continuous support during & after evaluation</h5></li>
                    </ul>
                    <h3 class="title-animation mb-10">Clinical Data Strategy</h3>
                    <p class="mb-30">SQUARE MEDTECH assists in planning and maintaining an efficient clinical data strategy from product development to post-market phases. A well-planned strategy expedites market entry and strengthens marketing efforts.</p>
                    <h3 class="title-animation mb-10">Clinical Evaluation Plan & Report</h3>
                    <p class="mb-30">We help develop and update clinical evaluation documentation to meet regulatory criteria, ensuring a systematic and ongoing validation of a device's safety and performance.</p>
                    <h3 class="title-animation mb-10">Clinical Evaluation SOP</h3>
                    <p class="mb-30">SQUARE MEDTECH supports in creating Standard Operating Procedures (SOPs) that outline processes and ensure compliance with regulatory requirements, making clinical evaluations efficient and standardized.</p>
                    <div class="row">
                        <div class="col-lg-7">
                            <div class="service-details__content-media-item service-details__content-media-item-1">
                                <div class="service-details__content-media-item_img mb-10">
                                    <img src="./assets/imgs/service-details/service-details-2.jpg" class="img-fluid" alt="img not found"/>
                                </div>
                                <h4 class="title-animation mb-15">Our Approach</h4>
                                <p>We ensure a well-structured clinical evaluation approach, aligning with regulatory requirements while optimizing resources to accelerate the approval process.</p>
                            </div>
                        </div>
                        <div class="col-lg-5">
                            <div class="service-details__content-media-item service-details__content-media-item-2">
                                <div class="service-details__content-media-item_img mb-10">
                                    <img src="./assets/imgs/service-details/service-details-3.jpg" class="img-fluid" alt="img not found"/>
                                </div>
                                <h4 class="title-animation mb-15">Why Choose Us?</h4>
                                <p>SQUARE MEDTECH specializes in clinical evaluations with a dedicated team of regulatory experts and healthcare professionals, ensuring compliance and efficiency at every stage.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>


       
    </main>


    <section class="footer__cta footer__cta-bottom-up">
    <div class="container">
        <div class="row mb-minus-30">
            <div class="col-md-6">
                <div class="footer__cta-item mb-30 theme-bg-primary d-flex flex-lg-row flex-column align-items-lg-center">
                    <div class="footer__cta-item-icon d-flex align-items-center justify-content-center">
                        <img class="img-fluid" src="/assets/imgs/footer__cta/footer__cta-item-1.png" alt="icon not found"/>
                    </div>

                    <div class="footer__cta-item-text">
                    <h4 class="color-white mb-15 mb-10">Our Clinical Evaluation Services</h4>
                    <ul class="color-white mb-0">
                      <li>Support for Safety & Performance</li>
                      <li>Develop and update CE documentations</li>
                      <li>Alignment with intended purpose, claims, and technical documentations</li>
                    </ul>
                    </div>
                </div>
            </div>

            <div class="col-md-6">
                <div class="footer__cta-item mb-30 theme-bg-glow d-flex flex-lg-row flex-column align-items-lg-center">
                    <div class="footer__cta-item-icon d-flex align-items-center justify-content-center">
                        <img class="img-fluid" src="/assets/imgs/footer__cta/footer__cta-item-2.png" alt="icon not found"/>
                    </div>

                    <div class="footer__cta-item-text">
                    <h4 class="color-white mb-15 mb-10">Our Clinical Evaluation Services</h4>
                    <ul class="color-white mb-0">
                      <li>Clinical Evidence Support</li>
                      <li>Efficient Clinical Data Strategy</li>
                      <li>Standard Operating Procedure</li>
                    </ul>

                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
    <FooterWhite/>

    </>
  )
}
